import React from 'react'

const Nota = ({mpio}) => {
  
  return (
    <>
      <h5 className="text-justify mt-4">
        NOTA: Las siguientes acciones manifestadas por el sujeto obligado no son objeto de plebiscito, pero podrían ser materia de referéndum, en el caso de que se emita la minuta/decreto respectivo: 
      </h5>
      <ul>
        {
          mpio === 'chochola' &&
          <>
            <li>
              Proyectos de la actualización sobre los reglamentos del medio ambiente, así como la modificación y adecuación del Bando de Gobierno del Municipio de Chocholá, Yucatán. 
            </li>
            <li>
              Se reafirmará la conmemoración del municipio en el mes de octubre. 
            </li>
          </> 
        }
        {
          mpio === 'dzidzantun' &&
          <>
            <li>
              Crear un programa de mejora normativa para las áreas de obras públicas y desarrollo urbano, catastro municipal y medio ambiente. 
            </li>
          </> 
        }
        {
          mpio === 'telchac-puerto' &&
          <>
            <li>
              Crear normativa enfocada al cuidado del medio ambiente  
            </li>
          </> 
        }
      </ul>
    </>
  )
}

export default Nota